/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserProfileInfo} from '../models/UserProfileInfo';

export interface GetUserInfo$Request {
    userId: number;
}

export interface GetUserInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserInfoRequest = createAction<PayloadData<void, GetUserInfo$Request>>('GET_USER_INFO__GET_USER_INFO__REQUEST');
export const getUserInfoSuccess = createAction<PayloadData<UserProfileInfo, GetUserInfo$Request>>('GET_USER_INFO__GET_USER_INFO__SUCCESS');
export const getUserInfoFailure = createAction<PayloadData<Error, GetUserInfo$Request, true>>('GET_USER_INFO__GET_USER_INFO__FAILURE');

export const getUserInfoActions = [
    getUserInfoRequest,
    getUserInfoSuccess,
    getUserInfoFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserInfo = (meta: GetUserInfo$Request, config?: GetUserInfo$Config) => {
    return {
        CALL_API: {
            types: getUserInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/profile/user-info`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

